export const defaultEmployeeResponding = -1;
